import { Patient } from './patient-base';


/**
* Plan model.
*/
export interface Plan {
	id: string;
	patientId: string;
	boneType: BoneTypeEnum;
	version: string;
	number: string;
	name?: string;
	userGuid: string;
	device: DeviceEnum;
	type: PlanTypeEnum;
	referenceType: ReferenceTypeEnum;
	side: AnatomicalSideEnum;
	isPostOperative: boolean;
	surgeryDate?: Date;
	notes?: string;
	apImageGuid?: string;
	ltImageGuid?: string;
	isReceived?: boolean;
	patient: Patient;
	isCheckUp?: boolean;
	creationDate?: Date;
}

export enum AnatomicalSideEnum {
	Left = 'Left',
	Right = 'Right'
}

export enum BoneTypeEnum {
	LongLeg = 'Long Leg',
	Femur = 'Femur',
	Tibia = 'Tibia'
}

export enum ReferenceTypeEnum {
	Proximal = 'Proximal',
	Distal = 'Distal'
}

export enum PlanTypeEnum {
	Deformity = 'Deformity',
	Fracture = 'Fracture'
}

export enum BoneViewEnum {
	AP = 'AP',
	LAT = 'LAT'
}

export enum DeviceEnum {
	ToBeDefined = 'ToBeDefined',
	Fitbone = 'Fitbone',
	Jps = 'Jps',
	Tlhex = 'Tlhex'
}
